module.exports = __webpack_public_path__ + "static/media/Elf3.6f2d3908.png";